import { FormPdfAltItem } from "@/cs-ts-bridge/ts/form-pdf-alt-item";
import { BaseElementDef, BaseElementDefBase } from "./BaseElementDef";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { CompletionRedirectSettings } from "@cs-ts/completion-redirect-settings";
import { CalculationContext } from "./__CalculationContextInterface";

export default class PdfAlternativeDef extends BaseElementDef<CompletionRedirectSettings, FormDefinitionItem<CompletionRedirectSettings>, FormPdfAltItem> {
    declare fileUrl: string | undefined;

    constructor(parentElement: BaseElementDefBase | null, elementData: FormPdfAltItem, definitionData: FormDefinitionItem<CompletionRedirectSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.typeName = "MI.Common.DynamicForms.Models.DFPdfAlternative"; // TODO - not hardcoded?
    }
    setData(data: FormPdfAltItem | null, excludeChildren?: boolean) {
        super.setData(data, excludeChildren);
        if (data == null) return;
        this.fileUrl = data.fileUrl;
    }
    getCustomPageNav() {
        return [this];
    }
}
